<template>
  <el-dialog
    :title="title"
    :visible.sync="visible"
    append-to-body
    width="50%">
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="110px" class="orgForm" :disabled="disabled">
      <el-form-item label="公证事项" prop="matter">
        <el-checkbox-group v-model="ruleForm.matter">
          <el-checkbox v-for="(item, index) in checkboxList" :key="index" :label="item.label" name="matter"></el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="份数" prop="name">
        <el-input-number v-model="ruleForm.num" size="small" :min="1" label="描述文字"></el-input-number>
      </el-form-item>
      
      <el-form-item>
        <el-button size="small" type="primary" @click="submitForm('ruleForm')">保存</el-button>
        <el-button size="small" @click="resetForm('ruleForm')">重置</el-button>
      </el-form-item>
    </el-form>
  </el-dialog>
</template>

<script>
export default {
  props: {
    openType: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      visible: false,
      title: '',
      ruleForm: {
        matter: [],
        num: 1,
      },
      disabled: false,
      rules: {
        applyDate: [{ required: true, message: "请选择日期", trigger: "change" }],
        notarizationType: [{ required: true, message: "请选择公证类别", trigger: "change" }],
        notary: [{ required: true, message: "请选择公证员", trigger: "change" }],
        assistant: [{ required: true, message: "请选择助理", trigger: "change" }],
        xieban: [{ required: true, message: "请选择协办人", trigger: "change" }],
        legalAidMatters: [{ required: true, message: "请选择", trigger: "change" }],
        translate: [{ required: true, message: "请选择", trigger: "change" }],
        emergencyLevel: [{ required: true, message: "请选择紧急程度", trigger: "change" }],
        purpose: [{ required: true, message: "请选择用途", trigger: "change" }]
      },
      checkboxList: [
        {
          value: 0,
          label: "遗嘱"
        },
        {
          value: 1,
          label: "死亡"
        },
        {
          value: 2,
          label: "学历"
        },
        {
          value: 3,
          label: "著作权"
        },
        {
          value: 4,
          label: "存款"
        },
        {
          value: 5,
          label: "不动产"
        }
      ]
    };
  },
  created() {
    
  },
  watch: {
    openType: {
      immediate: true,
      handler(newValue) {
        switch (newValue) {
          case "see":
            this.title = "查看公证信息";
            break;
          case "add":
            this.title = "新增公证信息";
            break;
          case "edit":
            this.title = "编辑公证信息";
            break;
          default:
            break;
        }
      }
    }
  },
  mounted() {

  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          alert('submit!');
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    open() {
      this.visible = true;
    },
    close() {
      this.visible = false;
    }
  }
}
</script>
<style lang="less" scoped>
.orgForm{
  width: 80%;
  margin: 0 auto;
}
.el-form-item{
  margin-bottom: 12px;
}
.el-select {
    display: inline-block;
    position: relative;
    width: 100%;
}

</style>